import { Skeleton } from "@/components/ui/skeleton";

// Fallback shown while a lazily-loaded route chunk is fetched. Kept lightweight
// (a couple of skeleton blocks) so it reads as "content loading" rather than a
// full-screen spinner; the surrounding layout/nav stays mounted.
export function RouteFallback() {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Loading">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-40 w-full rounded-xl" />
      <Skeleton className="h-40 w-full rounded-xl" />
    </div>
  );
}
